import SalesChart from './SalesChart';

export default SalesChart;
